import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const BusinessExamplesSection = styled.section`
  position: relative;
  margin-top: 160px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 40px;
    margin-top: 140px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 15px;
  }
`;

export const BusinessExamplesTitle = styled(Typography.Header)`
  text-align: center;
  margin-bottom: 60px;
  font-size: 34px;
  font-weight: 700;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 26px;
    margin-bottom: 40px;
  }
`;

export const BusinessExamplesScrollOuter = styled.div`
  position: relative;
  width: 100vw;
  margin-left: min(0px, calc((100vw - 1280px) / 2 * -1));
  margin-right: min(0px, calc((100vw - 1280px) / 2 * -1));

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: auto;
    margin-left: -40px;
    margin-right: -40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-left: -15px;
    margin-right: -15px;
  }
`;

export const BusinessExamplesScrollWrapper = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BusinessExamplesScrollButtonsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  pointer-events: none;
`;

export const BusinessExamplesContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;
  padding-bottom: 8px;
  padding-left: max(0px, calc((100vw - 1280px) / 2));
  padding-right: max(0px, calc((100vw - 1280px) / 2));

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding-left: 40px;
    padding-right: 40px;
    gap: 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const ExamplesScrollButton = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%)
    ${({ $side }) => ($side === 'right' ? ' rotate(180deg)' : '')};
  ${({ $side }) => ($side === 'left' ? 'left: 10px;' : 'right: 10px;')}
  z-index: 1000;
  pointer-events: auto;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: transparent;
  background-color: transparent;
  background-image: url('/images/shops/arrow-right.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
`;

export const BusinessExamplesScrollSpacer = styled.div`
  flex: 0 0 auto;
  min-width: max(0px, calc((100vw - 1280px) / 2));

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    min-width: 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-width: 15px;
  }
`;

export const BusinessExampleCard = styled.div`
  flex: 0 0 auto;
  border-radius: 28px;
  background: #fbece6;
  padding: 25px;
  width: 500px;
  height: 350px;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 330px;
    height: 295px;
    padding: 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 330px;
    max-width: calc(100vw - 30px);
    height: 295px;
    padding: 10px;
  }
`;

export const BusinessExampleContent = styled.div`
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 24px;
  padding: 25px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    gap: 12px;
  }
`;

export const BusinessExampleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BusinessExampleAvatar = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 48px;
    height: 48px;
  }
`;

export const BusinessExampleInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const BusinessExampleName = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 18px;
  }
`;

export const BusinessExampleCategory = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 13px;
  }
`;

export const BusinessExampleStatBlock = styled.div`
  padding: 15px;
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.secondary.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 12px;
  }
`;

export const BusinessExampleStatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 20px;
  }
`;

export const BusinessExampleStatLabel = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 13px;
  }
`;

export const BusinessExampleQuote = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-style: italic;
  flex: 1;
  align-content: end;

  &::before {
    content: '"';
  }

  &::after {
    content: '"';
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 13px;
  }
`;
